import { Box, styled, SxProps, Theme } from '@mui/material';

export const StyledEditorContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isFocused' && prop !== 'isHovered' && prop !== 'hasToolbar' && prop !== 'error',
})<{ isFocused: boolean; isHovered: boolean; hasToolbar: boolean; error?: boolean }>(
  ({ theme: { palette, spacing, wl }, isFocused, isHovered, hasToolbar, error }) => ({
    '.tox-tinymce': {
      border: `1px solid ${error ? palette.error.main : palette.divider}`,
      borderRadius: spacing(0.5),
      ...(error && {
        borderColor: palette.error.main,
      }),
      ...(!error &&
        isFocused && {
          borderColor: wl?.portal_accent_color || palette.primary.main,
        }),
      ...(!error &&
        !isFocused &&
        isHovered && {
          borderColor: palette.text.primary,
        }),
    },
    '.tox-tinymce .tox-editor-container, .tox-tinymce .tox-edit-area, .tox-tinymce .tox-edit-area__iframe': {
      height: '100% !important',
    },
    '.tox:not(.tox-tinymce-inline) .tox-editor-header': {
      borderBottom: hasToolbar ? `1px solid ${palette.divider} !important` : 'none',
      boxShadow: 'none',
    },
    '.tox svg': {
      fill: `${palette.action.active} !important`,
    },
  }),
);

export const editorTextStyles = ({ palette }: Theme) => `
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: ${palette.text.primary};
`;

const RESIZE_HANDLE_SIZE = 16;

export const resizeHandleStyles: SxProps<Theme> = ({ palette }) => ({
  position: 'absolute',
  right: 1,
  bottom: 1,
  zIndex: 1,
  width: RESIZE_HANDLE_SIZE,
  height: RESIZE_HANDLE_SIZE,
  cursor: 'ns-resize',
  touchAction: 'none',
  background: `linear-gradient(135deg, transparent 0 48%, ${palette.action.active} 48% 54%, transparent 54% 68%, ${palette.action.active} 68% 74%, transparent 74%)`,
});
